import {Loader} from '@components/mantine';
import {createRootRouteWithContext, Outlet} from '@tanstack/react-router';
import {lazy, Suspense} from 'react';
import {AuthenticationContextType, useAuthentication} from '../auth';

const DebugBar = __USE_DEBUG_BAR__
    ? lazy(async () => {
          const module = await import('@components/debug-bar');
          return {
              default: () => (
                  <module.DebugBar
                      toolsConfiguration={['OwnershipTool', 'TanstackReactQueryTool', 'TanstackReactRouterTool']}
                  />
              ),
          };
      })
    : (): null => null;

const RootLayout = () => {
    const {canAccess} = useAuthentication();
    return (
        <>
            {canAccess === undefined ? <Loader /> : <Outlet />}

            <Suspense>
                <DebugBar />
            </Suspense>
        </>
    );
};

export interface MyRouterContext {
    auth: AuthenticationContextType;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component: RootLayout,
});
